export default __webpack_public_path__ + "static/under18-brochure-3bd0da954671e4f77af95715a9c01bb8.png";